var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.977,
    height: 20.801,
    viewBox: "0 0 18.977 20.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M1.65,12.33A9.087,9.087,0,0,0,2.4,15.994a9.766,9.766,0,0,0,2.054,3.028,9.623,9.623,0,0,0,3.024,2.054,9.132,9.132,0,0,0,3.665.742,9.131,9.131,0,0,0,3.664-.742,9.719,9.719,0,0,0,5.082-5.082A9.349,9.349,0,0,0,20.152,9.4a9.569,9.569,0,0,0-1.34-2.592A9.3,9.3,0,0,0,16.79,4.774a.9.9,0,0,0-.7-.219.837.837,0,0,0-.7,1,1.081,1.081,0,0,0,.385.589A7.633,7.633,0,0,1,17.418,7.8,7.748,7.748,0,0,1,18.5,9.91a7.54,7.54,0,0,1,.387,2.42,7.47,7.47,0,0,1-.593,3.021,7.855,7.855,0,0,1-1.663,2.468,7.752,7.752,0,0,1-2.468,1.667,7.607,7.607,0,0,1-3.025.6,7.584,7.584,0,0,1-3.017-.6A7.781,7.781,0,0,1,4,15.351a7.9,7.9,0,0,1-.157-5.618A7.839,7.839,0,0,1,5.073,7.5,7.593,7.593,0,0,1,6.946,5.808a7.7,7.7,0,0,1,2.355-1V6.132q0,.508.311.64a.725.725,0,0,0,.717-.16L13.36,4.478a.7.7,0,0,0,.334-.559.669.669,0,0,0-.334-.558L10.337,1.218a.745.745,0,0,0-.725-.16q-.311.131-.311.649V3.038A9.178,9.178,0,0,0,6.284,4.206,9.738,9.738,0,0,0,3.852,6.3,9.608,9.608,0,0,0,2.231,9.084,9.118,9.118,0,0,0,1.65,12.33Z",
    transform: "translate(-1.65 -1.017)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshicon);
export default __webpack_public_path__ + "static/media/refresh icon.4ede1bc99bdba6ae29f721425e720ec9.svg";
export { ForwardRef as ReactComponent };